import { EventEmitter } from '@angular/core';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import { Observable, of, throwError } from 'rxjs';
import { Identity } from 'storage-service-lib';
import { environment } from '../../../environments/environment';
import { VerifyLoginOtpResponse } from '../../components/login/login.service';
import { IAuthService } from './iauthservice';

export abstract class AbstractAuthService implements IAuthService {
  protected constructor() {}

  getRedirectUri(): string {
    return `${environment.uiHost}/redirectPage.html`;
  }

  getToken(responseUrl: string): Observable<string> {
    const jwt = this.extractCode(responseUrl);
    if (!jwt) {
      return throwError(() => new Error('No JWT in response.'));
    }
    return of(jwt);
  }

  validToken(token: string): boolean {
    const decoded = jwtDecode<JwtPayload>(token);
    return decoded.exp !== undefined && !this.hasExpired(decoded.exp);
  }

  signIn(tenantName: string, options?: { env?: string }): Observable<any> {
    throw new Error('Method not implemented.');
  }

  signInWithOtp(decodedToken: any, otpObject: VerifyLoginOtpResponse, loginSuccess: EventEmitter<Identity>): void {
    throw new Error('Method not implemented.');
  }

  private hasExpired(dateTimeInSecondsSinceEpoch: number): boolean {
    return Date.now() >= dateTimeInSecondsSinceEpoch * 1000; // TODO: add leeway?
  }

  private extractCode(responseUrl: string): string | null {
    const url = new URL(responseUrl);
    return url.searchParams.get('token');
  }
}
